import axios from './axios';
import { DataStorageData } from '../../shared/types';
import { appConfig } from '../../config';

export const getTransactionData = async (transactionId: string): Promise<DataStorageData> => {
  const response = await axios.get<{ data: DataStorageData }>(`/api/transaction/${transactionId}`);

  return response?.data?.data;
};

export const shouldAuthTransaction = async (transactionId: string): Promise<{ shouldAuth: boolean }> => {
  const response = await axios.get<{ shouldAuth: boolean }>(`/api/transaction/${transactionId}/shouldAuth`);

  return response?.data;
};


export const createTransactionAndToken = async (data: any): Promise<DataStorageData> => {
  const response = await axios.post<{ data: DataStorageData; token: string }>(
    `/api/${appConfig.brandName}/transaction/create`,
    data
  );

  return { ...response?.data?.data, token: response?.data?.token };
};
